import { Modal, Result, Button } from 'antd';
import DeleteIcon from '@mui/icons-material/Delete';
import { statusTokens } from '../../../theme/theme';

const ConfirmDeleteCatalogModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    catalogName
}) => {
    return (
        <Modal
            open={isOpen}
            onCancel={onClose}
            centered
            footer={null}
        >
            <Result
                icon={<DeleteIcon style={{ color: statusTokens.error, fontSize: 64 }} />}
                title="Delete Catalog"
                subTitle={`Are you sure you want to delete the catalog "${catalogName || 'Untitled'}"? This action will remove the catalog from all user profiles.`}
                extra={[
                    <Button 
                        key="delete" 
                        danger 
                        type="primary" 
                        onClick={onConfirm}
                    >
                        Delete
                    </Button>,
                    <Button 
                        key="cancel" 
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                ]}
            />
        </Modal>
    );
};

export default ConfirmDeleteCatalogModal;
